import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-linux-auto",
  "use": "icon-soc-l1-linux-auto-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-linux-auto\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 320h640v384H192V320zm64 64v256h512V384H256z\" />\r\n  <path d=\"M320 192h384v96H320V192z\" />\r\n  <path d=\"M448 704h128v96H448v-96z\" />\r\n  <path d=\"M384 448h64v64H384v-64zm192 0h64v64h-64v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-linux-auto.svg
// module id = a0ea
// module chunks = 491